module.exports = __webpack_public_path__ + "img/events-header.d20dc14a.jpg";